import Button, { ButtonProps } from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import { forwardRef, MouseEventHandler } from 'react';
import { ICONS } from '@/assets/icons';
import Iconify from '@/components/Iconify';
import { PTypographyLoading } from '@/components/molecules/TypographyLoading/PTypographyLoading';
import { ICON_SIZE_MAP } from '@/config';
import { mergeSx } from '@/utils/cssStyles';

interface ChangeBuildingButtonProps {
  title: string;
  onClick: MouseEventHandler<HTMLButtonElement>;
  isSelected: boolean;
  tooltipText: string;
  /**
   * Lighter Typography style for the navigation selector button
   */
  compact?: boolean;
  variant?: ButtonProps['variant'];
  isLoading?: boolean;
  buttonSx?: ButtonProps['sx'];
}

const NavigationSelectorButton = forwardRef<HTMLButtonElement, ChangeBuildingButtonProps>(
  (
    { title, onClick, isSelected, tooltipText, compact = false, variant = 'text', isLoading = false, buttonSx },
    ref,
  ) => {
    const isTextVariant = variant === 'text';
    return (
      <Tooltip title={tooltipText} arrow placement="top">
        <Button
          ref={ref}
          disableRipple={isTextVariant}
          disableFocusRipple
          disableTouchRipple={isTextVariant}
          onClick={onClick}
          sx={mergeSx(
            {
              maxWidth: 400,
              minWidth: 'fit-content',
              p: 0,
              userSelect: 'text',
              '&:hover': {
                backgroundColor: isTextVariant ? 'transparent' : 'selected.main',
              },
            },
            buttonSx,
          )}
          variant={variant}
          endIcon={
            <Iconify
              icon={isSelected ? ICONS.CHEVRON_UP : ICONS.CHEVRON_DOWN}
              width={ICON_SIZE_MAP.md}
              height={ICON_SIZE_MAP.md}
            />
          }
        >
          <PTypographyLoading
            variant={compact ? 'body1' : 'h4'}
            noOverflow={{ maxWidth: 800, title }}
            isLoading={isLoading}
            loaderWidth={360}
            align={'left'}
          >
            {compact ? <strong>{title}</strong> : title}
          </PTypographyLoading>
        </Button>
      </Tooltip>
    );
  },
);

export default NavigationSelectorButton;
